import { render, staticRenderFns } from "./IconsSelect.vue?vue&type=template&id=c94adce4&scoped=true&"
import script from "./IconsSelect.vue?vue&type=script&lang=js&"
export * from "./IconsSelect.vue?vue&type=script&lang=js&"
import style0 from "./IconsSelect.vue?vue&type=style&index=0&id=c94adce4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94adce4",
  null
  
)

export default component.exports